import { ApiVersionEnum } from '../index.js'
import { getLocalStorage } from '@ipevo-rd/service-web-utils'
import { getHttpInstance } from '../api.js'
import { usePageLoadingStore } from '@shared-store'

// V1 HttpClient
export const v1HttpClient = getHttpInstance(ApiVersionEnum.V1)
	// 設定請求攔截器
	.setRequestInterceptor((config) => {
		// 取得Token
		const token = getLocalStorage('token')
		// 取得請求URL
		const { url } = config
        // 如果URL存在 且符合/s/XXXX0000格式
        if (url && /\/s\/[A-Z]{4}\d{4}/i.test(url)) {
            // 顯示頁面加載狀態
            usePageLoadingStore().showLoading()
        }

		// Token存在時
		if (token) {
			// 設定Authorization
			config.headers.Authorization = `Bearer ${token}`
		}

		return config
	})
	// 設定錯誤處理攔截器
	.setHandleRequestError((error) => {
		// 隱藏頁面加載狀態
		usePageLoadingStore().hideLoading()
		if (
			error.code === 'ECONNABORTED' &&
			error.message.indexOf('timeout') !== -1
		) {
			//請求超時
		}

		//取得錯誤訊息
		return Promise.reject(error)
	})
	// request 成功攔截器
	.setResponseInterceptor((response) => {
		// 隱藏頁面加載狀態
		usePageLoadingStore().hideLoading()

		//取得response
		let result

		// IE9時response.data是undefined，因此需要使用response.request.responseText
		if (response.data === undefined) {
			result = JSON.parse(response.request.responseText.data)
		} else {
			result = response.data
		}

		return result
	})
	// 設定錯誤處理攔截器
	.setHandleResponseError((err) => {
		// 隱藏頁面加載狀態
		usePageLoadingStore().hideLoading()
		//發生錯誤時，例如400 404 500
		if (
			String(err).indexOf('Network Error') > 0 ||
			String(err).indexOf('timeout') > 0 ||
			err.response.status === 400 ||
			err.response.status === 404 ||
			err.response.status === 500
		) {
			console.log(err)
		}

		//返回錯誤訊息
		return Promise.reject(err)
	})
